/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Box, BoxProps } from '@material-ui/core'
import { NUMBER_OF_TYPING_AGENT_DOTS_SHOWN } from '../../constants/chatHeaderConstants'
import { SSPX } from '../../constants/themeConstants'
import { waveAnimation } from '../../styles/animations/animations'
import { smartColors } from '../../styles/colors'

type OwnProps = {
	darker?: boolean
} & BoxProps

export const TypingBubbles = ({ darker = false, ...rest }: OwnProps) => (
	<Box
		bgcolor={darker ? smartColors.white : smartColors.lightGrey}
		display="flex"
		alignItems="center"
		borderRadius={8}
		position="relative"
		textAlign="center"
		p={2}
		{...rest}
	>
		{Array(NUMBER_OF_TYPING_AGENT_DOTS_SHOWN)
			.fill('')
			.map((_, index) => (
				<span key={index} css={dotCss(darker)} />
			))}
	</Box>
)

const dotCss = (darker: boolean) => css`
	display: inline-block;
	width: ${SSPX}px;
	height: ${SSPX}px;
	border-radius: 50%;
	margin-right: ${0.5 * SSPX}px;
	background: ${darker ? smartColors.blackTextColor : smartColors.darkerGrey};
	animation: ${waveAnimation} 1.3s linear infinite;

	&:nth-of-type(2) {
		animation: ${waveAnimation} 1.3s linear 1s infinite;
	}

	&:nth-of-type(3) {
		animation: ${waveAnimation} 1.3s linear 0.9s infinite;
	}
`
